import React from 'react';
import {Router, Switch, Route, Redirect} from 'react-router-dom';
import VendorRouteGuard from './components/VendorRouteGuard';
import {InquiryDetails as PackageInquiryDetails} from './components/packages';
import Users from './components/users';
import {SignInForm, SignUpForm} from './components/sessions';
import ResetPasswordPage from './components/sessions/ResetPasswordPage';
import {
	BookingDetails,
	Bookings,
	TicketDetails,
	PackageBookingDetails as UserPackageBookingDetails
} from './components/bookings';
import PrivateRoute from './components/PrivateRoute';
import ServiceTransactionList from './components/partners/ServiceTransactionList';
import {
	BecomePartnerForm,
	PartnerProfile,
	PartnerPackageBookings,
	PartnerCarBookings,
	PartnerTransactions,
	PackageForm as AddPackageForm,
	PackageForm as NewPackageForm
} from './components/partners';
import {HomePage, UserNotVerified, VerifyUser, InfoPage, PrivacyPolicy, TermsOfService, Blogs, PackagesPage, GroupTourismPage, SharedRentalsPage, VendorSignupPage, VendorOnboarding} from './components/pages';
import TravelServicesPage from './components/booking/TravelServicesPage';
import BookEverestBaseCampPage from './components/booking/BookEverestBaseCampPage';
import FlightsPage from './components/flights/FlightsPage';
import { AddPassengers, EditPassengers } from './components/flights';
import AdminFlightBookings from './components/admin/FlightBookings';
import DestinationDetailPage from './components/destinations/DestinationDetailPage';
import DistrictDetailPage from './components/destinations/DistrictDetailPage';
import ProvincesPage from './components/destinations/ProvincesPage';
import ProvinceDetailPage from './components/destinations/ProvinceDetailPage';
import GovernmentHubPage from './components/guides/GovernmentHubPage';
import TransportationHubPage from './components/guides/TransportationHubPage';
import LivingInNepalHubPage from './components/guides/LivingInNepalHubPage';
import SeasonalDiscoveryHubPage from './components/guides/SeasonalDiscoveryHubPage';
import ShoppingHubPage from './components/guides/ShoppingHubPage';
import ArrivalHubPage from './components/guides/ArrivalHubPage';
import SafetyHubPage from './components/guides/SafetyHubPage';
import LifecycleHubPage from './components/guides/LifecycleHubPage';
import KnowledgeIndexPage from './components/guides/KnowledgeIndexPage';
import NepalCoverageMapPage from './components/guides/NepalCoverageMapPage';
import TrendsHubPage from './components/guides/TrendsHubPage';
import FestivalsHubPage from './components/guides/FestivalsHubPage';
import TrekkingHubPage from './components/guides/TrekkingHubPage';
import TemplesHubPage from './components/guides/TemplesHubPage';
import FestivalDetailPage from './components/guides/FestivalDetailPage';
import GuideDetailPage from './components/guides/GuideDetailPage';
import GuidesIndexPage from './components/guides/GuidesIndexPage';
import JourneyRedirect from './components/journey/JourneyRedirect';
import GuidedJourneyPage from './components/journeys/GuidedJourneyPage';
import JourneyIndexPage from './components/journeys/JourneyIndexPage';
import { RedirectToPlaces, RedirectToPlan, RedirectPlanDream, RedirectPlanResearch, RedirectPlanChooseDestination } from './components/home/HomeRedirects';
import NoindexRedirect from './components/shared/NoindexRedirect';
import {CustomerSupport} from './components/pages';
import {PaymentSuccess} from './components/payments';
import PartnerDashboard from './components/partners/Dashboard';
import PartnerGroupToursList from './components/partners/PartnerGroupToursList';
import PartnerSharedRentalsList from './components/partners/PartnerSharedRentalsList';
import PartnerMyGroupTrips from './components/partners/PartnerMyGroupTrips';
import PartnerMySharedRentals from './components/partners/PartnerMySharedRentals';
import PartnerMyPrivateTours from './components/partners/PartnerMyPrivateTours';
import PartnerGroupTourFormPage from './components/partners/PartnerGroupTourFormPage';
import PartnerSharedRentalFormPage from './components/partners/PartnerSharedRentalFormPage';
import PartnerPrivateTourFormPage from './components/partners/PartnerPrivateTourFormPage';

import EditUserForm from './components/users/EditUserForm';

import TransactionList from './components/admin/TransactionList';
import CreateUser from './components/admin/CreateUser';
import UsersList from './components/admin/UsersList';
import PackageBookingList from './components/admin/PackageBookingList';
import FaqList from './components/admin/FaqList';
import FaqForm from './components/admin/FaqForm';
import UpdateBooking from './components/admin/CancelRequests';
import TransactionDetails from './components/admin/TransactionDetails';
import AdminBookingDetails from './components/admin/BookingDetails';
import UserEmail from './components/admin/UserEmail';
import Dashboard from './components/admin/Dashboard';
import AdminHomeRedirect from './components/admin/AdminHomeRedirect';
import PartnerList from './components/admin/PartnerList';
import PackagesList from './components/admin/PackagesList';
import PackageBookingDetails from './components/admin/PackageBookingDetails';
import InquiryDetails from './components/admin/InquiryDetails';
import InquiryForm from './components/packages/InquiryForm';
import CreateInquiry from './components/packages/CreateInquiry';
import PartnerDetails from './components/admin/PartnerDetails';
import InquiryList from './components/admin/InquiryList';
import CategoryList from './components/admin/CategoryList';
import CategoryDetail from './components/admin/CategoryDetail';
import CategoriesForm from './components/categories/CategoriesForm';
import EditInquiry from './components/admin/EditInquiry';
import AdminPackageDetails from './components/admin/PackageDetails';
import UserLayout from './components/layouts/UserLayout';
import AdminLayout from './components/layouts/AdminLayout';
import AppRoute from './components/AppRoute';
import PartnerLayout from './components/layouts/PartnerLayout';
import ServiceTransactions from './components/admin/ServiceTransactions';
import ServiceTransactionForm from './components/admin/ServiceTransactionForm';
import SummaryList from './components/admin/SummaryList';
import AddonList from './components/admin/AddonList';
import AddonDetails from './components/admin/AddonDetails';
import AddonForm from './components/admin/AddonForm';
import PackageServiceDetails from './components/partners/PackageServiceDetails';
import { SetPackageDetails } from './components/admin';
import GroupToursList from './components/admin/GroupToursList';
import GroupTourForm from './components/admin/GroupTourForm';
import GroupTourDetails from './components/admin/GroupTourDetails';
import ManageGroupTrips from './components/admin/ManageGroupTrips';
import ManageSharedRentals from './components/admin/ManageSharedRentals';
import ManagePrivateTours from './components/admin/ManagePrivateTours';
import BookingCalendar from './components/admin/BookingCalendar';
import SharedRentalsList from './components/admin/SharedRentalsList';
import SharedRentalForm from './components/admin/SharedRentalForm';
import SharedRentalDetails from './components/admin/SharedRentalDetails';
import PrivateToursList from './components/admin/PrivateToursList';
import PrivateTourForm from './components/admin/PrivateTourForm';
import PrivateTourDetails from './components/admin/PrivateTourDetails';
import AdminSettings from './components/admin/AdminSettings';
import AdminContentDashboard from './components/admin/cms/AdminContentDashboard';
import JourneysAdminList from './components/admin/cms/JourneysAdminList';
import JourneyAdminForm from './components/admin/cms/JourneyAdminForm';
import DestinationsAdminList from './components/admin/cms/DestinationsAdminList';
import DestinationAdminForm from './components/admin/cms/DestinationAdminForm';
import FestivalsAdminList from './components/admin/cms/FestivalsAdminList';
import FestivalAdminForm from './components/admin/cms/FestivalAdminForm';
import GuidesAdminList from './components/admin/cms/GuidesAdminList';
import GuideAdminForm from './components/admin/cms/GuideAdminForm';
import MediaAdminList from './components/admin/cms/MediaAdminList';
import MediaAdminForm from './components/admin/cms/MediaAdminForm';
import OfficialSourcesAdminList from './components/admin/cms/OfficialSourcesAdminList';
import OfficialSourceAdminForm from './components/admin/cms/OfficialSourceAdminForm';
import BookableJourneysAdminList from './components/admin/booking/BookableJourneysAdminList';
import BookableJourneyAdminForm from './components/admin/booking/BookableJourneyAdminForm';

// When user hits /package/:id, redirect to inquiry form (package details page bypassed).
const PackageRedirectToInquiry = ({ match }) => (
	<NoindexRedirect path={`/package/${match.params.id}`} to={`/inquiry_form/${match.params.id}`} />
);
const RedirectToHome = () => <NoindexRedirect to="/" />;
const RedirectToSharedRentals = () => <NoindexRedirect to="/shared-rentals" />;

const routes = [
	{private: false, path: '/login', component: SignInForm, layout: UserLayout, footer: true},
	{private: false, path: '/signup', component: SignUpForm, layout: UserLayout, footer: true},
	{private: false, path: '/reset-password', component: ResetPasswordPage, layout: UserLayout, footer: true},
	{private: false, path: '/flights', component: FlightsPage, layout: UserLayout, footer: true},
	{private: true, path: '/passengers', component: AddPassengers, layout: UserLayout, footer: true},
	{private: true, path: '/passengers/:ruid/edit', component: EditPassengers, layout: UserLayout, footer: true},
	{private: false, path: '/hotels', component: RedirectToHome, layout: UserLayout},
	{private: false, path: '/book-experiences', component: TravelServicesPage, layout: UserLayout, footer: true},
	{private: false, path: '/book-everest-base-camp-trek', component: BookEverestBaseCampPage, layout: UserLayout, footer: true},
	{private: false, path: '/packages', component: PackagesPage, layout: UserLayout, footer: true},
	{private: false, path: '/rentals', component: RedirectToSharedRentals, layout: UserLayout},
	{private: false, path: '/group-trips', component: GroupTourismPage, layout: UserLayout, footer: true},
	{private: false, path: '/shared-rentals', component: SharedRentalsPage, layout: UserLayout, footer: true},
	{private: false, path: '/journeys/:slug', component: GuidedJourneyPage, layout: UserLayout, footer: true},
	{private: false, path: '/journeys', exact: true, component: JourneyIndexPage, layout: UserLayout, footer: true},
	{private: false, path: '/journey/:stage/:stepParam?', component: JourneyRedirect, layout: UserLayout, footer: true},
	{private: false, path: '/destinations/:slug', component: DestinationDetailPage, layout: UserLayout, footer: true},
	{private: false, path: '/destinations', exact: true, component: RedirectToPlaces, layout: UserLayout, footer: true},
	{private: false, path: '/districts/:slug', component: DistrictDetailPage, layout: UserLayout, footer: true},
	{private: false, path: '/provinces/:slug', component: ProvinceDetailPage, layout: UserLayout, footer: true},
	{private: false, path: '/provinces', component: ProvincesPage, layout: UserLayout, footer: true},
	{private: false, path: '/shopping', component: ShoppingHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/safety', component: SafetyHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/plan-your-trip', component: RedirectToPlan, layout: UserLayout, footer: true},
	{private: false, path: '/plan/dream', component: RedirectPlanDream, layout: UserLayout, footer: true},
	{private: false, path: '/plan/research', component: RedirectPlanResearch, layout: UserLayout, footer: true},
	{private: false, path: '/plan/choose-destination', component: RedirectPlanChooseDestination, layout: UserLayout, footer: true},
	{private: false, path: '/knowledge-index', component: KnowledgeIndexPage, layout: UserLayout, footer: true},
	{private: false, path: '/coverage-map', component: NepalCoverageMapPage, layout: UserLayout, footer: true},
	{private: false, path: '/plan/:stageSlug', component: LifecycleHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/arrival', component: ArrivalHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/visa', component: GovernmentHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/government', component: GovernmentHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/transportation', component: TransportationHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/living-in-nepal', component: LivingInNepalHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/seasonal-discovery', component: SeasonalDiscoveryHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/travel-trends', component: TrendsHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/festivals/:slug', component: FestivalDetailPage, layout: UserLayout, footer: true},
	{private: false, path: '/festivals', component: FestivalsHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/trekking', component: TrekkingHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/temples', component: TemplesHubPage, layout: UserLayout, footer: true},
	{private: false, path: '/guides/:slug', component: GuideDetailPage, layout: UserLayout, footer: true},
	{private: false, path: '/guides', component: GuidesIndexPage, layout: UserLayout, footer: true, exact: true},
	// Package details page bypassed: /package/:id redirects to inquiry_form (see PackageRedirectToInquiry).
	{private: false, path: '/package/:id', component: PackageRedirectToInquiry, layout: UserLayout, footer: true},
	{private: false, path: '/blogs', component: Blogs, layout: UserLayout, footer: true},
	{private: false, path: '/about', component: InfoPage, layout: UserLayout, footer: true},
	{private: false, path: '/privacy', component: PrivacyPolicy, layout: UserLayout, footer: true},
	{private: false, path: '/terms', component: TermsOfService, layout: UserLayout, footer: true},
	{private: false, path: '/partners/new', component: BecomePartnerForm, layout: UserLayout},
	{private: false, path: '/vendor-signup', component: VendorSignupPage, layout: UserLayout, footer: true},
	{private: true, path: '/vendor/onboarding', component: VendorOnboarding, layout: UserLayout},
	{private: false, path: '/support', component: CustomerSupport, layout: UserLayout, footer: true},
	{private: false, path: '/confirm', component: UserNotVerified, layout: UserLayout, footer: true},
	{private: false, path: '/inquiry', component: InquiryForm, layout: UserLayout},
	{private: false, path: '/verify/:token', component: VerifyUser, layout: UserLayout, footer: true},

	{private: true, path: '/bookings', component: Bookings, layout: UserLayout},
	{private: true, path: '/transactions', component: Users, layout: UserLayout},
	{private: true, path: '/records', component: Users, layout: UserLayout},
	{private: true, path: '/profile/:idx', component: Users, layout: UserLayout},
	{private: true, path: '/users/edit', component: EditUserForm, layout: UserLayout},
	{private: true, path: '/booking/:id', component: BookingDetails, layout: UserLayout},
	{private: true, path: '/ticket/:id', component: TicketDetails, layout: UserLayout},

	{private: true, path: '/partner/service_transactions', component: ServiceTransactionList, layout: PartnerLayout},

	{private: true, path: '/package_booking/:idx', component: UserPackageBookingDetails, layout: UserLayout},

	{private: true, path: '/partners/package_form/:partnerId', component: AddPackageForm, layout: UserLayout},
	{private: true, path: '/admin/package_form', component: NewPackageForm, layout: UserLayout},
	{private: true, path: '/partner/package_details/:idx', component: PackageServiceDetails, layout: PartnerLayout},

	{private: true, path: '/admin/addons', component: AddonList, layout: AdminLayout},
	{private: true, path: '/admin/addon_details/:idx', component: AddonDetails, layout: AdminLayout},
	{private: true, path: '/admin/addon_form', component: AddonForm, layout: UserLayout},
	{private: true, path: '/admin/addon/:idx/edit', component: AddonForm, layout: AdminLayout},
{private: true, path: '/admin/group_tours', component: GroupToursList, layout: AdminLayout},
	{private: true, path: '/admin/manage_group_trips', component: ManageGroupTrips, layout: AdminLayout},
		{private: true, path: '/admin/group_tour_form/:idx', component: GroupTourForm, layout: AdminLayout},
		{private: true, path: '/admin/group_tour_form', component: GroupTourForm, layout: AdminLayout},
	{private: true, path: '/admin/group_tour_details/:idx', component: GroupTourDetails, layout: AdminLayout},
	{private: true, path: '/admin/shared_rentals', component: SharedRentalsList, layout: AdminLayout},
	{private: true, path: '/admin/manage_shared_rentals', component: ManageSharedRentals, layout: AdminLayout},
		{private: true, path: '/admin/shared_rental_form/:idx', component: SharedRentalForm, layout: AdminLayout},
		{private: true, path: '/admin/shared_rental_form', component: SharedRentalForm, layout: AdminLayout},
	{private: true, path: '/admin/shared_rental_details/:idx', component: SharedRentalDetails, layout: AdminLayout},
	{private: true, path: '/admin/private_tours', component: PrivateToursList, layout: AdminLayout},
	{private: true, path: '/admin/private_tour_form/:idx', component: PrivateTourForm, layout: AdminLayout},
	{private: true, path: '/admin/private_tour_form', component: PrivateTourForm, layout: AdminLayout},
	{private: true, path: '/admin/private_tour_details/:idx', component: PrivateTourDetails, layout: AdminLayout},
	{private: true, path: '/admin/flight_bookings', component: AdminFlightBookings, layout: AdminLayout},
	{private: true, path: '/admin/booking_calendar', component: BookingCalendar, layout: AdminLayout},
	{private: true, path: '/admin/booking_catalog/new', component: BookableJourneyAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/booking_catalog/:slug', component: BookableJourneyAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/booking_catalog', component: BookableJourneysAdminList, layout: AdminLayout},
	{private: true, path: '/admin/manage_private_tours', component: ManagePrivateTours, layout: AdminLayout},
	{private: true, path: '/admin/partners/:id', component: PartnerProfile, layout: UserLayout},
	{private: true, path: '/inquiry_details/:idx', component: PackageInquiryDetails, layout: UserLayout},
	{private: true, path: '/inquiry_form/:package_idx', component: CreateInquiry, layout: UserLayout},
	{private: true, path: '/admin/inquiry/:idx/edit', component: EditInquiry, layout: AdminLayout},
	{private: true, path: '/admin/package_booking_details/:idx', component: PackageBookingDetails, layout: UserLayout},
	{private: true, path: '/payment_success/:idx', component: PaymentSuccess, layout: UserLayout},

	{private: true, path: '/admin/:idx/set_package_details', component: SetPackageDetails, layout: AdminLayout},

	{private: true, path: '/admin/summaries', component: SummaryList, layout: AdminLayout},
	{private: true, path: '/admin/transaction/:idx', component: TransactionDetails, layout: AdminLayout},
	{private: true, path: '/admin/transactions', component: TransactionList, layout: AdminLayout},
	{private: true, path: '/admin/service_transactions', component: ServiceTransactions, layout: AdminLayout},
	{private: true, path: '/admin/service_transaction/new', component: ServiceTransactionForm, layout: AdminLayout},
	{private: true, path: '/admin/create_user', component: CreateUser, layout: AdminLayout},
	{private: true, path: '/admin/users_list', component: UsersList, layout: AdminLayout},
	{private: true, path: '/admin/users', component: () => <Redirect to="/admin/users_list" />, layout: AdminLayout},
	{private: true, path: '/admin/packages', component: PackagesList, layout: AdminLayout},
	{private: true, path: '/admin/package_details/:idx', component: AdminPackageDetails, layout: AdminLayout},
	{private: true, path: '/admin/partners', component: PartnerList, layout: AdminLayout},
	{private: true, path: '/admin/inquiry_details/:idx', component: InquiryDetails, layout: AdminLayout},
	{private: true, path: '/admin/inquiries', component: InquiryList, layout: AdminLayout},
	{private: true, path: '/admin/categories', component: CategoryList, layout: AdminLayout},
	{private: true, path: '/admin/package_booking', component: PackageBookingList, layout: AdminLayout},
	{private: true, path: '/admin/faqs', component: FaqList, layout: AdminLayout},
	{private: true, path: '/admin/category_details', component: CategoryDetail, layout: AdminLayout},
	{private: true, path: '/admin/category_form', component: CategoriesForm, layout: AdminLayout},
	{private: true, path: '/admin/faq/faq_form', component: FaqForm, layout: AdminLayout},
	{private: true, path: '/admin/faq/edit/:id', component: FaqForm, layout: AdminLayout},

	{private: true, path: '/admin/partner/:id', component: PartnerDetails, layout: AdminLayout},
	{private: true, path: '/admin/cancel_requests', component: UpdateBooking, layout: AdminLayout},
	{private: true, path: '/admin/bookings/:ruid', component: AdminBookingDetails, layout: AdminLayout},
	{private: true, path: '/admin/email', component: UserEmail, layout: AdminLayout},
	{private: true, path: '/admin/settings', component: AdminSettings, layout: AdminLayout},
	{private: true, path: '/admin/cms/journey_form/:slug', component: JourneyAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/journey_form', component: JourneyAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/journeys', component: JourneysAdminList, layout: AdminLayout},
	{private: true, path: '/admin/cms/destination_form/:slug', component: DestinationAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/destination_form', component: DestinationAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/destinations', component: DestinationsAdminList, layout: AdminLayout},
	{private: true, path: '/admin/cms/festival_form/:slug', component: FestivalAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/festival_form', component: FestivalAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/festivals', component: FestivalsAdminList, layout: AdminLayout},
	{private: true, path: '/admin/cms/guide_form/:slug', component: GuideAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/guide_form', component: GuideAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/guides', component: GuidesAdminList, layout: AdminLayout},
	{private: true, path: '/admin/cms/media_form/:id', component: MediaAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/media_form', component: MediaAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/media', component: MediaAdminList, layout: AdminLayout},
	{private: true, path: '/admin/cms/official_source_form/:slug', component: OfficialSourceAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/official_source_form', component: OfficialSourceAdminForm, layout: AdminLayout},
	{private: true, path: '/admin/cms/official_sources', component: OfficialSourcesAdminList, layout: AdminLayout},
	{private: true, path: '/admin/cms', component: AdminContentDashboard, layout: AdminLayout},
	{private: true, path: '/admin/:section', component: Dashboard, layout: AdminLayout},
	{private: true, path: '/admin', exact: true, component: AdminHomeRedirect, layout: AdminLayout},

	{private: true, path: '/partner/package_bookings', component: PartnerPackageBookings, layout: PartnerLayout},
	{private: true, path: '/partner/car_bookings', component: PartnerCarBookings, layout: PartnerLayout},
	{private: true, path: '/partner/group_tours', component: PartnerGroupToursList, layout: PartnerLayout},
	{private: true, path: '/partner/shared_rentals', component: PartnerSharedRentalsList, layout: PartnerLayout},
	{private: true, path: '/partner/group-trips/new', component: PartnerGroupTourFormPage, layout: PartnerLayout},
	{private: true, path: '/partner/group-trips/edit/:idx', component: PartnerGroupTourFormPage, layout: PartnerLayout},
	{private: true, path: '/partner/group-trips', component: PartnerMyGroupTrips, layout: PartnerLayout},
	{private: true, path: '/partner/shared-rentals/new', component: PartnerSharedRentalFormPage, layout: PartnerLayout},
	{private: true, path: '/partner/shared-rentals/edit/:idx', component: PartnerSharedRentalFormPage, layout: PartnerLayout},
	{private: true, path: '/partner/shared-rentals', component: PartnerMySharedRentals, layout: PartnerLayout},
	{private: true, path: '/partner/private-tours/new', component: PartnerPrivateTourFormPage, layout: PartnerLayout},
	{private: true, path: '/partner/private-tours/edit/:idx', component: PartnerPrivateTourFormPage, layout: PartnerLayout},
	{private: true, path: '/partner/private-tours', component: PartnerMyPrivateTours, layout: PartnerLayout},
	{private: true, path: '/partner/transactions', component: ServiceTransactionList, layout: PartnerLayout},
	{private: true, path: '/partner', component: PartnerDashboard, layout: PartnerLayout}
];

const routing = (
	<>
		<VendorRouteGuard />
		<Switch>
		<AppRoute exact path='/' component={HomePage} layout={UserLayout} footer={true} />
		{routes.map((route) => {
			const { private: isPrivate, component, layout, footer, path, exact } = route;
			const shared = { path, exact, component, layout, footer };
			return isPrivate ? (
				<PrivateRoute key={path} {...shared} />
			) : (
				<AppRoute key={path} {...shared} />
			);
		})}
		{/* Unknown or inaccessible route → home (no blank page) */}
		<AppRoute component={() => <Redirect to="/" />} layout={UserLayout} footer={true} />
		</Switch>
	</>
);

export default routing;
